import React from 'react';
import { KibRefreshIcon } from '@chewy/kib-icons-react';
import { noRecentOrdersImage } from './vetContent';

const ErrorListClinics = () => {
  const errorTitle = "We're having trouble fetching your clinics.";
  const errorText = 'You can try to refresh the page or come back later.';
  const refreshText = 'Refresh';

  function refreshPage() {
    window.location.reload();
  }

  return (
    <div className="pet-form-vet-list__error">
      <img
        src={noRecentOrdersImage}
        alt="error loading clinics"
        data-testid="pet-form-vet-list-error-img"
        className="pet-form-vet-list__error--img"
      />
      <div className="pet-form-vet-list__error--container">
        <div
          className="pet-form-vet-list__error--title"
          data-testid="pet-form-vet-list-error-title"
        >
          {errorTitle}
        </div>
        <div className="pet-form-vet-list__error--text" data-testid="pet-form-vet-list-error-text">
          {errorText}
        </div>
        <button
          type="button"
          className="pet-form-vet-list__error--refresh"
          onClick={refreshPage}
          data-testid="pet-form-vet-list-error-button"
        >
          {refreshText}
          <KibRefreshIcon
            data-testid="pet-form-vet-list-retry-icon"
            className="pet-form-vet-list__error--refreshIcon"
            role="img"
            aria-label="try again"
            focusable="false"
          />
        </button>
      </div>
    </div>
  );
};

export default ErrorListClinics;
